import { ensureDate, normalizeDateForVisibility } from './date';

/**
 * Compare giveaways for public display: later endDate first (extended / current
 * campaigns), then newer startDate. Avoids ordering by available slot count,
 * which pushed older giveaways with more empty slots above the current one.
 */
export function compareGiveawaysByRecency(a, b) {
  const endA = a?.endDate ? ensureDate(a.endDate) : null;
  const endB = b?.endDate ? ensureDate(b.endDate) : null;
  const tEndA = endA ? endA.getTime() : 0;
  const tEndB = endB ? endB.getTime() : 0;
  if (tEndA !== tEndB) return tEndB - tEndA;

  const startA = a?.startDate ? normalizeDateForVisibility(a.startDate) : null;
  const startB = b?.startDate ? normalizeDateForVisibility(b.startDate) : null;
  const tStartA = startA ? startA.getTime() : 0;
  const tStartB = startB ? startB.getTime() : 0;
  return tStartB - tStartA;
}
